import React from 'react'
import styled from 'styled-components'
import { device } from 'utils/device'
import { CustomLinks } from 'components'

const GetDataInformation = () => {
  return (
    <Container className="container">
      <h2>More Information about NSPA Data</h2>
      <p>
        Some helpful links with more detail about NSPA Data.
      </p>
      <List className="p-0">
        <CustomLinks location="GET_DATA.INFO"/>
      </List>
    </Container>
  )
}

const List = styled.ul`
  list-style: none;

  > li > button {
    color: ${({ theme }) => theme.palette.primary[3]};
    background-color: transparent;
    border: none;
    font-size: 0.9rem;
    padding: 0.3rem 0;

    &:hover {
      text-decoration: underline;
    }

    &:focus {
      outline: none;
    }
  }
`

const Container = styled.div`
  width: 70%;
  margin: 2rem auto;
  color: ${({ theme }) => theme.palette.grayscale[2]};

  p {
    max-width: 25rem;
    font-size: 0.9rem;
    font-weight: 100;

    > a {
      font-size: 0.9rem;
      font-weight: 400;
    }
  }



  @media ${device.mobileL} {
    width: 80%;
    padding: 0;
    margin-top: 0;
  }
`

export default GetDataInformation
